import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { SignUpStepTwoFormComponent } from './sign-up-step-two-form.component';
import { SubmitErrorStateMatcher } from './submit-error-state-matcher';

@Component({
  selector: 'app-sign-up-step-two-form-v2',
  styleUrls: ['../sign-up-form-v2.component.scss'],
  templateUrl: './sign-up-step-two-form-v2.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  providers: [SubmitErrorStateMatcher, { provide: ErrorStateMatcher, useExisting: SubmitErrorStateMatcher }],
})
export class SignUpStepTwoFormV2Component extends SignUpStepTwoFormComponent {}
